import useAlert from "hooks/useAlert";
import { useRef } from "react";
import posthog from "posthog-js";

import { Paragraph } from "components/atoms/Typography";
import { Button } from "components/atoms/Button";
import { ExportIcon } from "components/atoms/Icon";

import useDownloadState from "recoilStore/useDownloadState";
import useMutationExportBuildingsForFilterset from "ApiLayer/Building/mutationExportBuildingsForFilterset";

interface ExportFiltersetButtonProps {
    filtersetUid: string | null;
    reportedVsPublished: string;
}

function ExportFiltersetButton({ filtersetUid, reportedVsPublished }: ExportFiltersetButtonProps) {
    const alert = useAlert();
    const fileName = "filterExport.csv";
    const { setState: setDownloadState } = useDownloadState();
    const controller = useRef<AbortController>();
    const { mutate: mutateExportBuildingsForFilterset, isLoading: isExportingBuildings } =
        useMutationExportBuildingsForFilterset();

    const handleExportButtonClick = () => {
        if (filtersetUid === null) {
            return;
        }
        posthog.capture("Export Reports");
        controller.current = new AbortController();
        setDownloadState((prev) => ({
            ...prev,
            controller: controller.current,
        }));
        mutateExportBuildingsForFilterset(
            { filtersetUid, reportedVsPublished },
            {
                onSuccess: ({ downloadLink }: { downloadLink: string }) => {
                    alert.success("...export done, saving file.");
                    setDownloadState((prev) => ({
                        ...prev,
                        downloadComplete: true,
                    }));
                    console.log(`opening window to ${downloadLink}`);
                    // const url = window.URL.createObjectURL(new Blob([downloadLink]));
                    const a = document.createElement("a");
                    // a.href = url
                    a.href = downloadLink;
                    a.download = fileName;
                    // a.target = "_new";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    // window.URL.revokeObjectURL(url);
                    window.URL.revokeObjectURL(downloadLink);
                },
                onError: (error) => {
                    setDownloadState((prev) => ({
                        ...prev,
                        downloadError: true,
                    }));
                },
            }
        );
    };

    return (
        <Button
            style={{ marginLeft: "8px" }}
            disabled={isExportingBuildings}
            type="secondary"
            onClick={handleExportButtonClick}
        >
            <ExportIcon />
            <Paragraph>{isExportingBuildings ? "Exporting..." : "Export"}</Paragraph>
        </Button>
    );
}

export default ExportFiltersetButton;
